import React, { useCallback, useEffect, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { callAdmin } from "./shared";

const ACTION_LABEL = {
  lock: "Locked account", unlock: "Unlocked account", chat_ban: "Chat ban", chat_unban: "Chat ban removed",
  role_set: "Made moderator", role_removed: "Removed moderator", delete_account: "Deleted account",
  gift_player: "Gift to player", gift_online: "Gift to online players", gift_all: "Gift to every player",
  backup_create: "Created backup", restore: "Restored database",
};

// Foldable moderation log (newest first).
export function ModLog() {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const load = useCallback(async () => { const r = await callAdmin("get", "/logs"); if (r) setRows(r); }, []);
  useEffect(() => {
    if (!open) return;
    load();
    window.addEventListener("admin-log-refresh", load);
    return () => window.removeEventListener("admin-log-refresh", load);
  }, [open, load]);

  return (
    <div className="rounded-xl border border-[#39194D] bg-[#12082B]" data-testid="admin-log">
      <button data-testid="admin-log-toggle" onClick={() => setOpen(o => !o)} className="w-full flex items-center gap-2 p-4 font-heading text-sm neon-cyan">
        {open ? <ChevronDown size={16} /> : <ChevronRight size={16} />} Moderation log
      </button>
      {open && (
        <div className="px-4 pb-4 max-h-96 overflow-y-auto pvp-scroll">
          {rows.length === 0 && <div className="font-mono text-xs text-[#A89BCC]">No actions yet.</div>}
          <table className="w-full font-mono text-xs">
            <tbody>
              {rows.map(r => (
                <tr key={r.log_id} data-testid={`admin-log-row-${r.log_id}`} className="border-t border-[#39194D] align-top">
                  <td className="py-1.5 pr-3 text-[#A89BCC] whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</td>
                  <td className="py-1.5 pr-3 text-[#FFE600] whitespace-nowrap">{r.actor_name}</td>
                  <td className="py-1.5 pr-3 text-white whitespace-nowrap">{ACTION_LABEL[r.action] || r.action}</td>
                  <td className="py-1.5 pr-3 text-[#00F0FF] whitespace-nowrap">{r.target_name || "—"}</td>
                  <td className="py-1.5 text-[#E5DCFF] break-words">
                    {r.reason}
                    {r.details?.until !== undefined && <span className="text-[#A89BCC]"> ({r.details.until ? "until " + new Date(r.details.until).toLocaleString() : "permanent"})</span>}
                    {r.details?.amount && <span className="text-[#A89BCC]"> {r.details.amount} HS → {r.details.recipients} player(s)</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
